import styled from 'styled-components';
import VideoHeaderSVG from '../../assets/header/ic-video.svg';

const VideoHeaderIcon = styled(VideoHeaderSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.1rem'};
  fill: ${props => props.color};
  margin: ${props => props.margin};
`;

export default VideoHeaderIcon;
